import React, { useState, useEffect } from 'react';
import GetLoading from "../../share/getLoading";
import { Modal, Button, Transfer, message, Select, Row, Col, Checkbox, InputNumber, TreeSelect, List } from 'antd';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MdDragIndicator } from 'react-icons/md';
import { request } from "../../share/request";
import { getCurrentUser, getListOrginzation } from "../../share/getProfile";
import DepartmentList from "../../component/list/DepartmentList";

const reportMockData = [
  { key: "image", title: "រូបថត" },
  { key: "tel", title: "លេខទូរស័ព្ទ" },
  { key: "idnumber", title: "លេខមន្ត្រីរាជការ" },
  { key: "full_name", title: "ឈ្មោះបុគ្គលិក" },
  { key: "english_name", title: "ឈ្មោះ ឡាតាំង" },
  { key: "shift", title: "ការកំណត់ស្គែនម៉ោង" },
  { key: "gender", title: "ភេទ" },
  { key: "department", title: "ផ្នែក" },
  { key: "position", title: "តួនាទី" },
  { key: "title_name", title: "ឈ្មោះ ខាងមុខ" },
  { key: "dob", title: "ថ្ងៃខែកំណើត" },
  { key: "join_date", title: "ថ្ងៃចូលធ្វើការ" },
  { key: "skill", title: "ជំនាញ" },
  { key: "level", title: "កាំប្រាក់ " },
  { key: "last_level_up", title: "ថ្ងៃចុងក្រោយឡើងកាំប្រាក់" },
  { key: "staff_type", title: "ប្រភេទបុគ្គលិក" },
  { key: "status", title: "ស្ថានភាពការងារ" },
];

const SortableItem = ({ item, checked, onToggle }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.key });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: 'white',
    zIndex: transform ? 1 : 0,
    position: transform ? 'relative' : 'static',
  };

  return (
    <List.Item
      ref={setNodeRef}
      style={style}
    >
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Checkbox checked={checked} onChange={onToggle} style={{ marginRight: 8 }} />
        <span style={{ flex: 1, cursor: 'pointer' }} onClick={onToggle}>{item.title}</span>
        <div {...attributes} {...listeners} style={{ cursor: 'grab', padding: '0 8px', display: 'flex', alignItems: 'center' }}>
          <MdDragIndicator size={20} style={{ color: '#999' }} />
        </div>
      </div>
    </List.Item>
  );
};

const UserReportModal = ({ visible, onClose }) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filterDepartment, setFilterDepartment] = useState([]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterStaffType, setFilterStaffType] = useState(null);

  // New config states
  const [mergeDepartment, setMergeDepartment] = useState(false);
  const [avatarShape, setAvatarShape] = useState('circle');
  const [avatarSize, setAvatarSize] = useState(40);
  const [filterOrg, setFilterOrg] = useState(null);
  const [treeData, setTreeData] = useState([]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      setTargetKeys((prev) => {
        const oldIndex = prev.indexOf(active.id);
        const newIndex = prev.indexOf(over.id);
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  useEffect(() => {
    const fetchOrg = async () => {
      const orgs = await getListOrginzation();
      if (orgs && orgs[0]) {
        const builtTree = orgs[0].reduce((acc, item) => {
          const groupId = item.group_id || "Unknown";
          const groupName = item.group_name || item.org_name_kh;
          const group = acc.find((g) => g.value === groupId);
          if (group) {
            group.children.push({
              title: item.org_name_kh,
              label: item.org_name_kh,
              value: item.org_code,
              key: item.organization_id,
            });
          } else {
            acc.push({
              title: `${groupName}`,
              label: `${groupName}`,
              value: groupId,
              key: `${groupId}`,
              children: [{
                title: item.org_name_kh,
                label: item.org_name_kh,
                value: item.org_code,
                key: item.organization_id,
              }],
            });
          }
          return acc;
        }, []);
        setTreeData(builtTree);
      }
    };
    fetchOrg();

    const user = getCurrentUser();
    if (user && user.org_code) {
      setFilterOrg(user.org_code);
    }
  }, []);

  const handleGenerate = async () => {
    if (targetKeys.length === 0) {
      message.warning("សូមជ្រើសរើសវាលយ៉ាងហោចណាស់មួយ (Please select at least one field)");
      return;
    }

    setLoading(true);
    try {
      const getProfileOrg = getCurrentUser();
      const res = await request("user/reportdynamic", "post", {
        targetKeys,
        org_code: filterOrg || getProfileOrg.org_code,
        department: filterDepartment && filterDepartment.length > 0 ? filterDepartment.join(',') : null,
        status: filterStatus,
        staff_type: filterStaffType && filterStaffType.length > 0 ? filterStaffType.join(',') : null
      });
      console.log('restdata', res)
      if (res && res.list) {
        // Prepare data with column headers for the HTML page
        const reportData = {
          keys: targetKeys,
          columns: targetKeys.map(key => reportMockData.find(d => d.key === key)),
          rows: res.list,
          config: {
            mergeDepartment,
            avatarShape,
            avatarSize
          }
        };

        localStorage.setItem("staff_report_data", JSON.stringify(reportData));
        message.success("កំពុងរៀបចំរបាយការណ៍...");
        window.open("/reportstaff.html", "_blank");
      } else {
        message.error("មិនមានទិន្នន័យ (No data found)");
      }
    } catch (err) {
      console.error(err);
      message.error("មានបញ្ហាក្នុងការទាញរបាយការណ៍ (Error generating report)");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <div className="sprinSave"><GetLoading /></div>}
      <Modal
        style={{ fontFamily: "'Hanuman', serif" }}
        title={<span style={{ fontFamily: "'Hanuman', serif", fontWeight: 'bold' }}>កំណត់រចនាសម្ព័ន្ធរបាយការណ៍បុគ្គលិក</span>}
        open={visible}
        onCancel={onClose}
        width={800}
        footer={[
          <Button key="close" onClick={onClose} style={{ fontFamily: "'Hanuman', serif" }}>
            បោះបង់
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={handleGenerate} style={{ fontFamily: "'Hanuman', serif" }}>
            ទាញរបាយការណ៍
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 20 }}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div style={{ marginBottom: 5, fontFamily: "'Hanuman', serif" }}>ជ្រើសរើសស្ថាប័ន</div>
              <TreeSelect
                style={{ width: '100%' }}
                className="styleTageStatusForm"
                value={filterOrg}
                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                treeData={treeData}
                placeholder="ជ្រើសរើសស្ថាប័ន (Select Organization)"
                treeDefaultExpandAll
                showSearch
                allowClear
                onChange={(val) => {
                  setFilterOrg(val);
                  setFilterDepartment([]); // Clear departments when org changes
                }}
                treeNodeFilterProp="title"
              />
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 5, fontFamily: "'Hanuman', serif" }}>ជ្រើសរើសផ្នែក</div>
              <DepartmentList
                orgCode={filterOrg}
                selectedDepartments={filterDepartment}
                onChange={setFilterDepartment}
                placeholder="ស្វែងរក និងជ្រើសរើសនាយកដ្ឋាន..."
                showCode={true}
                multiple={true}
                allowClear={true}
                maxTagCount={5}
                showSelectAll={true}
              />
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 5, fontFamily: "'Hanuman', serif" }}>ស្ថានភាពការងារ</div>
              <Select
                style={{ width: '100%', fontFamily: "'Hanuman', serif" }}
                placeholder="ជ្រើសរើសស្ថានភាពការងារ"
                allowClear
                value={filterStatus}
                onChange={setFilterStatus}
              >
                <Select.Option value="ធ្វើការ">ធ្វើការ</Select.Option>
                <Select.Option value="ព្យួរ">ព្យួរ</Select.Option>
                <Select.Option value="បណ្តុះបណ្តាល">បណ្តុះបណ្តាល</Select.Option>
                <Select.Option value="ឈប់">ឈប់</Select.Option>
              </Select>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 5, fontFamily: "'Hanuman', serif" }}>ប្រភេទបុគ្គលិក</div>
              <Select
                style={{ width: '100%', fontFamily: "'Hanuman', serif" }}
                placeholder="ជ្រើសរើសប្រភេទបុគ្គលិក"
                allowClear
                value={filterStaffType}
                onChange={setFilterStaffType}
                mode="tags"
                maxTagCount={2}
              >
                <Select.Option value="រដ្ឋ">រដ្ឋ</Select.Option>
                <Select.Option value="កិច្ចសន្យា">កិច្ចសន្យា</Select.Option>
                <Select.Option value="ជួល">ជួល</Select.Option>
                <Select.Option value="ផ្សេងៗ">ផ្សេងៗ</Select.Option>
              </Select>
            </Col>
          </Row>
        </div>

        <div style={{ marginBottom: 20, padding: '10px', background: '#0870c02e', borderRadius: '4px' }}>
          <div style={{ marginBottom: 10, fontFamily: "'Hanuman', serif", fontWeight: 'bold' }}>ការកំណត់បន្ថែម</div>
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col span={24}>
              <Checkbox
                checked={mergeDepartment}
                onChange={e => setMergeDepartment(e.target.checked)}
                style={{ fontFamily: "'Hanuman', serif" }}
              >
                បញ្ចូលជួរនាយកដ្ឋាន
              </Checkbox>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontFamily: "'Hanuman', serif" }}>រាងរូបថត:</span>
                <Select value={avatarShape} onChange={setAvatarShape} style={{ width: 120, fontFamily: "'Hanuman', serif" }}>
                  <Select.Option value="circle">រង្វង់</Select.Option>
                  <Select.Option value="square">ការ៉េ</Select.Option>
                </Select>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontFamily: "'Hanuman', serif" }}>ទំហំ (កំពស់ x ទទឹង):</span>
                <InputNumber value={avatarSize} onChange={setAvatarSize} min={10} max={200} />
                <span>PX</span>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ marginBottom: 5, fontFamily: "'Hanuman', serif" }}>ជ្រើសរើសជួរឈរ</div>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <Transfer
            style={{ fontFamily: "'Hanuman', serif" }}
            dataSource={reportMockData}
            titles={[
              <span style={{ fontFamily: "'Hanuman', serif" }}>មិនទាន់ជ្រើសរើស</span>,
              <span style={{ fontFamily: "'Hanuman', serif" }}>បានជ្រើសរើស</span>
            ]}
            targetKeys={targetKeys}
            onChange={(newTargetKeys) => setTargetKeys(newTargetKeys)}
            render={(item) => item.title}
            listStyle={{
              width: 350,
              height: 400,
            }}
          >
            {({
              direction,
              filteredItems,
              onItemSelect,
              selectedKeys: listSelectedKeys,
            }) => {
              if (direction === 'left') {
                return (
                  <div style={{ height: 340, overflow: 'auto' }}>
                    <List
                      size="small"

                      dataSource={filteredItems}
                      renderItem={(item) => {
                        const checked = listSelectedKeys.includes(item.key);
                        return (
                          <List.Item

                            onClick={() => onItemSelect(item.key, !checked)}
                            style={{ cursor: 'pointer', fontFamily: 'Hanuman' }}
                          >
                            <Checkbox checked={checked} style={{ marginRight: 8 }} />
                            {item.title}
                          </List.Item>
                        );
                      }}
                    />
                  </div>
                );
              }

              const sortedFilteredItems = [...filteredItems].sort((a, b) => targetKeys.indexOf(a.key) - targetKeys.indexOf(b.key));

              return (
                <div style={{ height: 340, overflow: 'auto', paddingBottom: '30px' }}>
                  <SortableContext
                    items={sortedFilteredItems.map(i => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <List
                      size="small"
                      style={{ fontFamily: 'Hanuman' }}
                      dataSource={sortedFilteredItems}
                      renderItem={(item) => (
                        <SortableItem
                          key={item.key}
                          item={item}
                          checked={listSelectedKeys.includes(item.key)}
                          onToggle={() => onItemSelect(item.key, !listSelectedKeys.includes(item.key))}
                        />
                      )}
                    />
                  </SortableContext>
                </div>
              );
            }}
          </Transfer>
        </DndContext>
      </Modal>
    </>
  );
};

export default UserReportModal;
